import styled from 'styled-components';

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(8px);
  opacity: 0;
  animation: fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
`;

export const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 40px;
  max-width: 450px;
  width: 100%;
  position: relative;
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.12),
    0 4px 16px rgba(0, 0, 0, 0.08);
  transform: scale(0.96);
  opacity: 0;
  animation: scaleIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0.05s forwards;

  @keyframes scaleIn {
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    padding: 32px 24px;
    margin: 0 16px;
    max-width: none;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 28px;
  color: #717171;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  line-height: 1;

  &:hover {
    background-color: #f7f7f7;
    color: #000000;
  }

  &:active {
    background-color: #e8e8e8;
  }

  &:focus {
    outline: 2px solid #000000;
    outline-offset: 2px;
  }
`;

export const ModalHeader = styled.div`
  margin-bottom: 32px;
  padding-right: 32px;
`;

export const ModalTitle = styled.h2`
  font-size: 26px;
  font-weight: 600;
  color: #000000;
  margin: 0 0 12px 0;
  line-height: 1.2;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

export const ModalSubtitle = styled.p`
  font-size: 16px;
  color: #484848;
  margin: 0;
  line-height: 1.5;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const PrimaryButton = styled.button<{ disabled?: boolean }>`
  flex: 1;
  background: ${props => props.disabled ? '#e0e0e0' : '#000000'};
  color: ${props => props.disabled ? '#999999' : '#ffffff'};
  border: none;
  border-radius: 8px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 56px;
  letter-spacing: 0.01em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  &:hover {
    background: ${props => props.disabled ? '#e0e0e0' : '#222222'};
    transform: ${props => props.disabled ? 'none' : 'translateY(-1px)'};
    box-shadow: ${props => props.disabled ? 'none' : '0 4px 12px rgba(0, 0, 0, 0.15)'};
  }

  &:active {
    transform: ${props => props.disabled ? 'none' : 'translateY(0)'};
  }

  &:focus {
    outline: 2px solid #000000;
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 18px 24px;
    min-height: 60px;
  }
`;

export const SecondaryButton = styled.button<{ disabled?: boolean }>`
  flex: 1;
  background: #ffffff;
  color: ${props => props.disabled ? '#cccccc' : '#000000'};
  border: 2px solid ${props => props.disabled ? '#e0e0e0' : '#000000'};
  border-radius: 8px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 56px;
  letter-spacing: 0.01em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  &:hover {
    background: ${props => props.disabled ? '#ffffff' : '#f7f7f7'};
    transform: ${props => props.disabled ? 'none' : 'translateY(-1px)'};
    box-shadow: ${props => props.disabled ? 'none' : '0 4px 12px rgba(0, 0, 0, 0.08)'};
  }

  &:active {
    transform: ${props => props.disabled ? 'none' : 'translateY(0)'};
    background: ${props => props.disabled ? '#ffffff' : '#e8e8e8'};
  }

  &:focus {
    outline: 2px solid #000000;
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 18px 24px;
    min-height: 60px;
  }
`;
